import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from 'core/fields/system/dependencies/components/dependencies-list';

export default class DependantsField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.DEPENDANTS;
    }

    static getValue(item) {
        return item.successors
        // return item.successors ? item.successors : [];
    }

    get sortHintMessage() {
        return 'Sort by dependants';
    }

    getCsvValue(item) {
        return _.map(DependantsField.getValue(item).models, successor=>"#{0}".f(successor.shortId)).join(', ');
    }

    getValue(item) {return DependantsField.getValue(item)}

    listItemSortFunctions(sort) {
        return {
            functions: [i => DependantsField.getValue(i.item) || 0],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null);
    }
}